/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 498);
/******/ })
/************************************************************************/
/******/ ({

/***/ 3:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/**

 * JavaScript functions for SIW_IPP_TAB.HTS - v1.0 Chris Salt
 * 11/03/2014
 * 24/09/2014 - Remove function from global namespace
 */



__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {

    var displayVal,
        data = {};

    try {
        data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.parseJSON(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#siw_ipp_tab_data').text());
    } catch (e) {}

    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isEmptyObject(data) === false) {

        displayVal = function displayVal(value, fieldName) {
            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.type(value) !== 'undefined') {
                if (value.length > 0) {
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + fieldName).find('#' + fieldName + 'Val').text(value).parent().removeClass('hidden');
                }
            }
        };

        if (data.json.hasOwnProperty('ipu')) {
            displayVal(data.json.ipu.ipu_code, 'tabIPURef');
        }

        if (data.json.hasOwnProperty('ipr')) {
            displayVal(data.json.ipr.ipr_bref, 'tabAppRef');
        }

        if (data.json.hasOwnProperty('mua')) {
            displayVal(data.json.mua.mua_alis, 'muaAlias');
        }

        if (data.json.hasOwnProperty('ipp')) {
            //displayVal(data.json.ipp.fac_name, 'tabFaculty');
            //displayVal(data.json.ipp.dpt_name, 'tabSchool');
            displayVal(data.json.ipp.ipp_titl, 'tabProg');
        }

        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#ipuSurname').val().length === 0) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loggedInUser').hide();
        }

        if (data.json.hasOwnProperty('genericHelp')) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#genericHelpTitle').html(data.json.genericHelp.title);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#genericHelpContent').html(data.json.genericHelp.content);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#navBarHelp').show();
        }

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#navBarInfoButton').popover({
            content: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#ippTabWidget').html()
        });
    }
});

/***/ })

/******/ });


// WEBPACK FOOTER //
// ku/js/siw_ipp_tab.js